namespace app.pesquisaAvancada {
    "use strict";
    
    import RouteConfig = app.support.command.RouteConfig;
    import Properties = app.support.constants.Properties;
    
    interface IPesquisaAvancada {
        description: string;
        route: RouteConfig;
        permitAll: boolean;
    }
    
    class SaveSearchCommand {
        
        public criteria: string;
        
        constructor(public uuid: string, public description: string, public context: string, 
                public executable: boolean, criteria: Array<Criterion>) {
            this.criteria = JSON.stringify(criteria);
        }
    }

    class ExportSearchCommand {        
        
        constructor(public uuid: string, public context: string, public users: Array<string>) {            
        }

    }

    export class PesquisaAvancadaService {

        private apiSearchs: string = "/integracoes-modulos/api/queries/searches";
        private apiSavedSearchs: string = "/integracoes-modulos/api/searches";
        private apiExportSearchs: string = "/integracoes-modulos/api/searches/export";
        private badgeValues = {};

        /** @ngInject **/
        constructor(private $http: ng.IHttpService, private msNavigationService,
                private $rootScope: ng.IRootScopeService, private properties: Properties, private $q) {
            $rootScope.$on("user:logged", () => this.loadQueries());
            $rootScope.$on("user:exited", () => this.resetQueries());
            
            this.apiSearchs = this.properties.apiUrl + this.apiSearchs;
            this.apiSavedSearchs = this.properties.apiUrl + this.apiSavedSearchs;
            this.apiExportSearchs = this.properties.apiUrl + this.apiExportSearchs;
        }
        
        public loadQueries(): void {
            this.$http.get(this.apiSearchs)
                .then((response: ng.IHttpPromiseCallbackArg<IPesquisaAvancada[]>) => {
                    response.data
                            .filter(pesquisa => angular.isObject(pesquisa.route))
                            .forEach(pesquisa => this.addRouteToNavigation(pesquisa));
                });
        }
        
        public resetQueries(): void {
            let navigation: Array<any> = this.msNavigationService.getNavigation();
            _.remove(navigation, (nav) => nav._id === "pesquisa-avancada");
        }
        
        public executeSearch(searchApi: string, search: ISearch): ng.IPromise<Array<any>> {
            let searchData : ISearch = angular.copy(search);
            searchData.criteria.forEach(criterion => { 
                if (criterion.comparisonOperator === ComparisonOperator.BETWEEN) {
                    criterion.value = JSON.stringify(criterion.value); //Serializa valores de critério em array para padronizar saída
                }
            })
            return this.$http.post(searchApi, searchData).then(response => {
                return <Array<any>> response.data;
            });
        }
        
        public saveSearch(search: ISearch): ng.IPromise<ISearch> {
            let command = new SaveSearchCommand(search.uuid, search.description, search.context, search.executable, search.criteria);
            return this.$http.post(this.apiSavedSearchs, command)
                        .then((response: ng.IHttpPromiseCallbackArg<string>) => {
                            search.uuid = response.data;
                            return search;
                        });
        }
        
        public deleteSearch(search: ISearch): ng.IPromise<any> {
            return this.$http.delete(`${this.apiSavedSearchs}/${search.context}/${search.uuid}`);
        }
        
        public loadSavedSearchs(context: string): ng.IPromise<ISearch[]> {
            let config = {params: {context: context}};
            return this.$http.get(this.apiSavedSearchs, config)
                        .then(response => <ISearch[]> response.data);
        }

        public exportSearch(uuid: string, context: string, users: Array<string> ): ng.IPromise<any> {
            let command = new ExportSearchCommand(uuid, context, users);
            return this.$http.post(this.apiExportSearchs, command);
        }
        
        private addRouteToNavigation(pesquisa: IPesquisaAvancada): void {
            if (!this.hasParent()) {
                this.msNavigationService.saveItem("pesquisa-avancada", {
                    title : "PESQUISA AVANÇADA",
                    group : true,
                    translation : "PESQUISA-AVANCADA.PESQUISA-AVANCADA",
                    weight : 3
                });
                this.msNavigationService.sort();
            }

            if (pesquisa.route.apiBadge) {
                this.$http.get(`${this.properties.apiUrl}/${pesquisa.route.context}/${pesquisa.route.apiBadge}`)
                    .then((response: ng.IHttpPromiseCallbackArg<number>) => {
                        var qtd = response.data;
                        this.badgeValues[pesquisa.route.id] = qtd;
                        this.atualizarBadge(pesquisa, qtd, false);
                    });
            }

            if (pesquisa.route.updateBadgeEventName) {
                this.$rootScope.$on(pesquisa.route.updateBadgeEventName, (event, toState, toParams) => {
                    var qtd = this.badgeValues[pesquisa.route.id] + toState.content;
                    this.badgeValues[pesquisa.route.id] = qtd;
                    this.atualizarBadge(pesquisa, 0, false); 
                    if (qtd > 0) {
                        setTimeout(() => {                        
                            this.atualizarBadge(pesquisa, this.badgeValues[pesquisa.route.id], true);
                        }, 50);
                    }
                });
            }
            this.criarRoute(pesquisa, null);
        }

        private atualizarBadge(pesquisa, valor, alert) {
            let route: RouteConfig = pesquisa.route;
            if (valor) {
                this.msNavigationService.saveItem(route.navigationItem, { badge : { color: 'red', content: valor, alert: alert } });
            } else {
                this.msNavigationService.saveItem(route.navigationItem, { badge : null });
            }
        }

        private criarRoute(pesquisa, badge) {
            let route: RouteConfig = pesquisa.route;
            const typeUi2: boolean = !!(route.types && route.types.find(x => x == 'ui2'));

            if (!!route.navigationItem) {   
                if (!!route.stateName) {
                    this.msNavigationService.saveItem(route.navigationItem, {
                        title : pesquisa.description,
                        icon : (route["icon"] !== null)? route["icon"]:"icon-magnify",
                        state : typeUi2 ? `app.upgraded({url: '${this.removeSlashKeyAtStart(route.url)}'})` : route.stateName,
                        translation : route.translation,
                        badge : badge
                    });
                } else {
                    // Se tem navigationItem mas não tem stateName, é um agrupador no menu.
                    this.msNavigationService.saveItem(route.navigationItem, {
                        title : route.translation,
                        group : true,
                        translation : route.translation,
                        weight : this.msNavigationService.getNavigation().length + 1
                    });
                    this.msNavigationService.sort();
                }
            } else if (typeUi2 && !pesquisa.permitAll) {
                this.msNavigationService.saveItem(`pesquisa-avancada.${route.id}`, {
                    title : pesquisa.description,
                    icon : (route["icon"] !== null)? route["icon"]:"icon-magnify",
                    state : `app.upgraded({url: '${this.removeSlashKeyAtStart(route.url)}'})`,
                    translation : route.translation,
                    badge : badge
                });
            }
        }

        private removeSlashKeyAtStart(url) {
            if (!!url && url[0] == '/') {
                return url.substr(1);
            }
            return url;
        }

        private hasParent(): boolean {
            let navigation: Array<any> = this.msNavigationService.getNavigation();
            return navigation.filter(nav => nav._id === "pesquisa-avancada").length > 0;
        }

    }
        
    angular
        .module("app.pesquisa-avancada")
        .service("app.pesquisa-avancada.PesquisaAvancadaService", PesquisaAvancadaService);
}